import { ThemeProvider as StyledThemeProvider } from "styled-components";
import { PropsWithChildren } from "react";

import { CSSReset } from "./reset";
import { theme } from "./theme";

const StylesProvider = ({ children }: PropsWithChildren<any>): JSX.Element => (
    // @ts-expect-error - styled-components ThemeProvider type compatibility issue with React 18
    <StyledThemeProvider theme={theme}>
        {/* @ts-expect-error - styled-components GlobalStyle type compatibility issue with React 18 */}
        <CSSReset />
        {children}
    </StyledThemeProvider>
);

export default StylesProvider;
